import { color } from 'styles/pallete';

export const returnColor = (value: string) => {
	switch (value) {
		case 'success':
			return `${color.system.success}`;
		case 'error':
			return `${color.system.error}`;
		case 'warning':
			return `${color.system.warning}`;
		case 'info':
			return `${color.system.info}`;

		default:
			return `${color.system.info}`;
	}
};
